import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { getWebLevelFontSizes, getWebLevelBottomMargins } from './styles.js';
import { ContentText } from '../ContentText/ContentText.web.js';
import { useTheme } from '../utils/theming/useTheme.js';

var getTag = function getTag(level) {
  switch (level) {
    case 1:
      return 'h1';

    case 2:
      return 'h2';

    case 3:
      return 'h3';

    case 4:
      return 'h4';

    case 5:
      return 'h5';
  }
};

var Heading = function Heading(props) {
  var children = props.children,
      _props$level = props.level,
      level = _props$level === void 0 ? 1 : _props$level,
      styledAs = props.styledAs,
      lineHeight = props.lineHeight,
      weight = props.weight,
      _props$contentHeading = props.contentHeading,
      contentHeading = _props$contentHeading === void 0 ? false : _props$contentHeading,
      _props$italic = props.italic,
      italic = _props$italic === void 0 ? false : _props$italic,
      ref = props.innerRef,
      rest = _objectWithoutProperties(props, ["children", "level", "styledAs", "lineHeight", "weight", "contentHeading", "italic", "innerRef"]);

  var tag = getTag(level);
  var theme = useTheme().heading.web;
  var fontSize = getWebLevelFontSizes(theme, styledAs || level);
  var marginBottom = getWebLevelBottomMargins(theme, styledAs || level);
  return (
    /*#__PURE__*/
    React.createElement(ContentText, _extends({
      "data-test": "elemental-Heading-".concat(level),
      as: tag,
      lineHeight: lineHeight ? lineHeight : theme.font.lineHeight,
      weight: weight ? weight : theme.font.weight,
      marginBottom: contentHeading ? marginBottom : 0,
      italic: italic,
      innerRef: ref,
      fontSize: fontSize
    }, rest), children)
  );
};

export { Heading };